module.exports = __webpack_public_path__ + "img/67-l.bab9f764.png";